import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import TableRowButton from 'jsx/elements/buttons/TableRowButton';
import Table from 'jsx/elements/tables/Table';
import { apiGetCall, apiPostCall } from './../../components/special/apiCall';
import { useLocale } from './../../components/special/LanguageProvider';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useErrorContext } from './../../components/messages/ErrorBox';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const TransactionKeyList = (props)  => {
  const [list, setList] = useState([]);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

  const isResultOk = (obj) => {
    if ((obj != null) && (obj.error != undefined)){
        setCheckErrorItems([obj]);
        return null;
    }
    return obj;
  }

  const loadList = async () =>{
    setIsPageLoading(true);
    const data = await apiGetCall(BASE_URL + '/admin/transactionkey/summary/');
    if (isResultOk(data)){
      setList(data);
    }
    setIsPageLoading(false);  
  }

  useEffect( () => {     
      loadList();     
  }, []);

  const onChangeClick = (transactionKeyID) => {
    props.history.push('/admin/transactionkeys/edit?transactionkeyid=' + transactionKeyID );
  }

  const onDeleteClick  = async(transactionKeyID) => {
    setIsPageLoading(true);
    const data = await apiPostCall(BASE_URL + '/admin/transactionkey/remove', {itemID : transactionKeyID});
    if (isResultOk(data)){
      await loadList();
    }
    setIsPageLoading(false); 
  }


  

  return (
    <div>
      <div className="grid tight collapse480">
          <div className="col s6of12">
              <h1 className="text-red text-32">Færslulyklar</h1>
          </div>
          <div className="col s6of12 ">
              <div className="button-group text-right">
                  <Link to="/admin/transactionkeys/edit?newkey=true" className="no-print button gray-light icon-plus pointer-edit">Skrá færslulykil</Link>
              </div>
          </div>
      </div>
      {list.length > 0 && (
        <div>
          <ReactTooltip/>
          <Table
          cols={['', '20%', '', '', '', '']}
          head={[
            'Færslulykill',
            'Númer',
            'Forsendur',
            'Færslulyklahópur',
            'Reikna',
            ''
          ]}
          hover="true"
        >
          {list.map((item, index) => 
            <tr key={index}>
              <td>
                {item.key}
              </td>
              <td>
                <Link to={"/admin/transactionkeys/edit?transactionkeyid=" + item.transactionKeyID}  data-tip="Breyta færslulykil">{item.name}</Link>                
              </td>
              <td>
                {item.transactionOwnerTypeName ? item.transactionOwnerTypeName : '' }<br/>
                {item.transactionCategoryTypeName ? item.transactionCategoryTypeName : '' }<br/>
                {item.transactionNatureTypeName ? item.transactionNatureTypeName : '' }
              </td>
              <td>
                {/* <Link to={{ pathname: '/admin/transaction-groups/EditTransactionGroup', 
                state: { transactionGroupID: item.transactionGroupID } }} 
                data-tip="Breyta hóp">{transactionKeyGroups.length > 0 && transactionKeyGroups.find(group => group.transactionGroupID === item.transactionGroupID).name}</Link> */}
              </td>
              <td>
                {item.calculateInterest && <span className="tag tag-color-red-secondary" data-tip="Reikna dráttavexti">Dráttavextir</span>}
                {item.calculateVAT && <span className="tag tag-color-green" data-tip="Reikna virðisaukaskatt">VSK</span>}
              </td>
              <td>
                <TableRowButton allowdelete="true" allowchange="true" 
                  onDeleteClick={() => onDeleteClick(item.transactionKeyID)} 
                  onChangeClick={() => onChangeClick(item.transactionKeyID)}
                ></TableRowButton>
              </td>
            </tr>
          )} 
        </Table>
        </div>
      )}
  </div>
  );
};
